var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _circle7, _circle8, _circle9, _circle10, _path6, _path7, _circle11, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotifSession1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 715,
    viewBox: "0 0 390 715",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 422.5,
    r: 32.5,
    fill: "#143162"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 487.5,
    r: 32.5,
    fill: "#0052A4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 617.5,
    r: 32.5,
    fill: "#0052A4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 552.5,
    r: 32.5,
    fill: "#66DDC0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.4997,
    cy: 617.5,
    r: 5.41666,
    fill: "#66DDC0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.416,
    cy: 422.5,
    r: 5.41666,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 455C79.5507 455 65 440.449 65 422.5C65 404.55 79.5507 390 97.5 390L162.5 390C180.449 390 195 404.55 195 422.5C195 440.449 180.449 455 162.5 455L97.5 455Z",
    fill: "#66DDC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292.5 649.999C274.55 649.999 260 635.449 260 617.499C260 599.55 274.55 585 292.5 585L357.5 584.999C375.449 584.999 390 599.55 390 617.499C390 635.449 375.449 649.999 357.5 649.999L292.5 649.999Z",
    fill: "#66DDC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 714.999C14.5507 714.999 -6.36033e-07 700.449 -1.42062e-06 682.499C-2.20521e-06 664.55 14.5507 649.999 32.5 649.999L97.4999 649.999C115.449 649.999 130 664.55 130 682.499C130 700.449 115.449 714.999 97.4999 714.999L32.5 714.999Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195 552.5C195 570.449 180.449 585 162.5 585C144.551 585 130 570.449 130 552.5L130 487.5C130 469.55 144.551 455 162.5 455C180.449 455 195 469.55 195 487.5L195 552.5Z",
    fill: "#143162"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195 520L130 520L130 487.5C130 469.55 144.551 455 162.5 455C180.449 455 195 469.55 195 487.5L195 520Z",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#143162"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 97.4999,
    r: 32.5,
    fill: "#0052A4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 227.5,
    r: 32.5,
    fill: "#0052A4"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 162.5,
    r: 32.5,
    fill: "#66DDC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 64.9999C79.5507 64.9999 65 50.4492 65 32.5C65 14.5507 79.5507 -6.99336e-06 97.5 -6.20878e-06L162.5 -3.36754e-06C180.449 -2.58295e-06 195 14.5507 195 32.5C195 50.4492 180.449 64.9999 162.5 64.9999L97.5 64.9999Z",
    fill: "#66DDC0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 325C14.5507 325 6.36033e-07 310.449 1.42062e-06 292.5C2.20521e-06 274.551 14.5507 260 32.5 260L97.4999 260C115.449 260 130 274.551 130 292.5C130 310.449 115.449 325 97.4999 325L32.5 325Z",
    fill: "#DDE2E9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.5,
    cy: 292.5,
    r: 32.5,
    fill: "#0052A4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195 162.5C195 180.449 180.449 195 162.5 195C144.551 195 130 180.449 130 162.5V97.4999C130 79.5507 144.551 65 162.5 65C180.449 65 195 79.5507 195 97.4999V162.5Z",
    fill: "#143162"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M195 130H130V97.4999C130 79.5506 144.551 64.9999 162.5 64.9999C180.449 64.9999 195 79.5507 195 97.4999V130Z",
    fill: "#DDE2E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotifSession1);
export default __webpack_public_path__ + "static/media/motif-session-1.60090c92e98418eee6771052560862ab.svg";
export { ForwardRef as ReactComponent };